import { Box, Grid, Typography } from '@mui/material';
import { FC } from 'react';
import { getCoverLevelText, getDemandsAndNeedsWording } from '@acorn-portal/shared/src/utils/constants';
import { CoverLevel, Product } from '@acorn-portal/shared/src/services/interface/Shared';

interface ICoverLevel {
	coverLevel: CoverLevel;
	product: Product;
}
const DemandsNeeds: FC<ICoverLevel> = ({ coverLevel, product }) => {
	const copyText = getDemandsAndNeedsWording(coverLevel, product);

	if (!copyText) return null;
	return (
		<Box sx={{ pb: 4 }}>
			<Grid container alignItems='center'>
				<Grid sx={{ flex: 1 }}>
					<Typography sx={{ fontWeight: 'bold', mb: 1 }}>Level of Cover - {getCoverLevelText(coverLevel)}</Typography>
					<Typography>{copyText}</Typography>
				</Grid>
			</Grid>
		</Box>
	);
};

export default DemandsNeeds;

// Usage:
